export default {
  name: "Scenario3D",
  props: {
    data: Object,
  },
  created() {},
};
